import { CacheableDataObject } from 'models/CacheableDataObject';

export default class Game extends CacheableDataObject {
	logoUrl() {
		return this.logo;
	}
}